import { HttpParams, HttpResponse } from '@angular/common/http';

export function trimFilterParams(body: object): HttpParams {
    let queryParams = new HttpParams();

    for (const [key, value] of Object.entries(body)) {
        if (
            value !== null &&
            value !== undefined &&
            value !== '' &&
            value !== 0 &&
            value !== 'null' &&
            !(Array.isArray(value) && value.length === 0)
        ) {
            queryParams = queryParams.append(key, value as string);
        }
    }

    return queryParams;
}

export function downloadFileFromBlob(response: HttpResponse<Blob>, defaultFileName?: string): void {
    const blob = response.body!;
    const contentDisposition = response.headers.get('Content-Disposition');

    let filename = defaultFileName;

    if (contentDisposition) {
        const matches = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);

        if (matches?.[1]) {
            filename = matches[1].replace(/['"]/g, '');
        }
    }

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');

    a.href = url;
    a.download = filename!;
    a.click();

    window.URL.revokeObjectURL(url);
}
